import { SyncStatus } from '../../shared/models';

export type BlightPersistedSyncStatus =
  | SyncStatus.syncInitialized
  | SyncStatus.awaitingBlightCalculation
  | SyncStatus.blightCalculationDone
  | SyncStatus.synced
  | SyncStatus.failedToSync
  | SyncStatus.none;

export const isBlightSyncStatusRecalculating = (syncStatus: string | null | undefined): boolean =>
  syncStatus === SyncStatus.syncInitialized || syncStatus === SyncStatus.awaitingBlightCalculation;
